module.exports = __webpack_public_path__ + "static/media/booking.562299d4.jpeg";